import { CreerObjetMaquetteRequest } from '@pcscol/odf-api-v1-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { Command } from './command';
import { CommandEvents } from './command-events';

/**
 * Cette commande crée un objetMaquette qui va être utilisée comme racine de l'éditeur
 */
export class CreerObjetMaquetteCommand implements Command<ObjetMaquette> {
    private createdObjetMaquette: string;

    constructor(
        private codeStructure: string,
        private events: CommandEvents,
        private objetMaquetteService: ObjetMaquetteService,
        private creerObjetMaquetteRequest: CreerObjetMaquetteRequest
    ) {}

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService.creerObjetMaquette(this.creerObjetMaquetteRequest).pipe(
            tap(om => {
                this.events.objetMaquetteCree$.next(om);
                this.createdObjetMaquette = om.id!;
            })
        );
    }

    destroy() {}
}
